<template>
  <div class="tools02-tag-detail-tag-editor">
    <el-row>
      <el-col :span="4">
        <a :href="toolData.manualData.tagRegistrationManualUrl" target="_blank" rel="noopener noreferrer">
          <Button2 type2="1" class="manual-button" msg="マニュアル" />
        </a>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center">
      <el-col :span="18">
        <table class="typeB">
          <tr v-if="toolData.codeKebab === 'yda-cv'">
            <th>
              <span>バージョン</span>
            </th>
            <td>
              <el-radio v-model="tagData.versionId" label="0">旧</el-radio>
              <el-radio v-model="tagData.versionId" label="1">新</el-radio>
              <ValidationErrorMessages :errorMessageList="validationErrorData.versionId" />
            </td>
          </tr>
          <tr v-if="tagData.versionId !== ''">
            <th>
              <span>
                <span v-if="
                  toolData.codeKebab === 'facebook-cv' ||
                  toolData.codeKebab === 'tiktok-cv'
                ">ピクセル</span>
                <span v-else-if="toolData.codeKebab === 'yda-cv'">コンバージョン</span>
                <span v-else-if="toolData.codeKebab === 'line-cv'">LINE Tag</span>
                <span v-else-if="toolData.codeKebab === 'smartnews-cv'">ピクセル</span>
                <span>名</span>
              </span>
            </th>
            <td>
              <el-input v-model="tagData.name"></el-input>
              <ValidationErrorMessages :errorMessageList="validationErrorData.name" />
              <ValidationErrorMessages :errorMessageList="facebookValidationErrorData.name" />
            </td>
          </tr>
          <template v-if="tagData.versionId !== ''">
            <tr v-if="toolData.codeKebab === 'yda-cv' && tagData.versionId === '1'">
              <th>
                <span>スニペットID</span>
              </th>
              <td>
                <el-input v-model="tagData.ydaSnippetId"></el-input>
                <ValidationErrorMessages :errorMessageList="validationErrorData.ydaSnippetId" />
              </td>
            </tr>
            <tr v-else>
              <th>
                <span>
                  <span v-if="
                    toolData.codeKebab === 'facebook-cv' ||
                    toolData.codeKebab === 'tiktok-cv'
                  ">ピクセルID</span>
                  <span v-else-if="toolData.codeKebab === 'line-cv'">LINE Tag ID</span>
                  <span v-else-if="toolData.codeKebab === 'yda-cv'">yahoo_ydn_conv_io</span>
                  <span v-else-if="toolData.codeKebab === 'smartnews-cv'">ピクセルタグID</span>
                </span>
              </th>
              <td>
                <el-input v-model="tagData.mediaTagId"></el-input>
                <div v-if="toolData.codeKebab === 'smartnews-cv'" class="note">
                  SmartNews Ads の管理画面で発行したPixelタグのタグID（24桁の英数字）。Pixelタグのコード内の SmartnewsAds.p("ここの値", "PageView"); に入っています。
                </div>
                <ValidationErrorMessages :errorMessageList="validationErrorData.mediaTagId" />
                <ValidationErrorMessages :errorMessageList="facebookValidationErrorData.pixelIdForApi" />
              </td>
            </tr>
          </template>
          <tr v-if="toolData.codeKebab === 'smartnews-cv'">
            <th>
              <span>ビジネスマネージャー</span>
            </th>
            <td>
              <el-select v-model="tagData.accountId" placeholder="選択してください">
                <el-option v-for="accountData in accountList" :key="accountData.accountId"
                  :label="`${accountData.accountName}（${accountData.accountCode}）`"
                  :value="accountData.accountId"></el-option>
              </el-select>
              <div class="note">
                このピクセルを発行した広告アカウントが属するビジネスマネージャーを選んでください。未登録の場合は、先に「ビジネスマネージャー登録」から登録してください。
              </div>
              <div v-if="accountList.length === 0">
                <router-link :to="`/tools02/${toolData.codeKebab}/accounts`">ビジネスマネージャー登録へ</router-link>
              </div>
              <ValidationErrorMessages :errorMessageList="validationErrorData.accountId" />
            </td>
          </tr>
          <tr v-if="
            toolData.codeKebab === 'facebook-cv' ||
            toolData.codeKebab === 'tiktok-cv' ||
            toolData.codeKebab === 'line-cv' ||
            (toolData.codeKebab === 'yda-cv' && tagData.versionId === '0')
          ">
            <th>
              <span v-if="
                toolData.codeKebab === 'facebook-cv' ||
                toolData.codeKebab === 'tiktok-cv' ||
                toolData.codeKebab === 'line-cv'
              ">アクセストークン</span>
              <span v-else-if="toolData.codeKebab === 'yda-cv'">yahoo_ydn_conv_label</span>
            </th>
            <td>
              <el-input v-model="tagData.accessToken"></el-input>
              <ValidationErrorMessages :errorMessageList="validationErrorData.accessToken" />
              <ValidationErrorMessages :errorMessageList="facebookValidationErrorData.accessToken" />
            </td>
          </tr>
        </table>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center">
      <el-col>
        <div class="button-cover">
          <el-button v-if="toolData.codeKebab !== 'facebook-cv'" @click="register" type="primary">登録</el-button>
          <el-button v-else @click="registerPixelData" type="primary">登録</el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Button2 from "@/components/Ui/Button2.vue";
import ValidationErrorMessages from "@/components/Ui/ValidationErrorMessages.vue";

export default {
  name: "Tools02TagDetailTagEditor",
  components: {
    Button2,
    ValidationErrorMessages,
  },
  props: {
    toolId: String,
    accountId: String,
    tagId: String,
  },
  data() {
    return {
      tagData: {
        accountId: "",
        versionId: "",
        name: "",
        mediaTagId: "",
        accessToken: "",
        ydaSnippetId: "",
        testCode: "",
      },
      validationErrorData: {
        accountId: [],
        versionId: [],
        name: [],
        mediaTagId: [],
        accessToken: [],
        ydaSnippetId: [],
        testCode: [],
      },
      facebookValidationErrorData: {
        userPixelId: [],
        name: [],
        pixelIdForApi: [],
        accessToken: [],
        testCode: [],
      },
    };
  },
  computed: {
    ...mapGetters(["rt", "apiErrorMessage", "userData"]),
    toolData() {
      return this.$store.getters["toolData"](this.toolId);
    },
    accountList() {
      return this.$store.getters["tools02/accounts"](this.toolId);
    },
  },
  watch: {
    tagId: {
      handler(newTagId) {
        if (newTagId !== "0") {
          this.tagData = JSON.parse(
            JSON.stringify(
              this.$store.getters["tools02/tagData"](this.toolId, newTagId)
            )
          );
        } else {

          // 
          if (this.toolData.codeKebab === 'yda-cv') {
            // no action.
          } else {
            this.tagData.versionId = '0';
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    register() {
      //
      let mediaTagId = this.tagData.mediaTagId;
      let accessToken = this.tagData.accessToken;
      let ydaSnippetId = '';
      if (this.toolData.codeKebab === 'yda-cv') {
        if (this.tagData.versionId === '1') {
          mediaTagId = 'xxxxx';
          accessToken = 'xxxxx';
          ydaSnippetId = this.tagData.ydaSnippetId;
        } else {
          // no action.
        }
      } else {
        // no action.
      }

      // SmartNews Ads は、ピクセルタグを登録する画面で選んだビジネスマネージャーに紐づける
      let accountId = this.accountId;
      if (this.toolData.codeKebab === 'smartnews-cv') {
        accountId = this.tagData.accountId;
      } else {
        // no action.
      }

      //
      let params = new URLSearchParams();
      params.append("tag_id", this.tagId);
      params.append("tool_id", this.toolId);
      params.append("account_id", accountId);
      params.append("version_id", this.tagData.versionId);
      params.append("name", this.tagData.name);
      params.append("media_tag_id", mediaTagId);
      params.append("access_token", accessToken);
      params.append("yda_snippet_id", ydaSnippetId);
      params.append("test_code", this.tagData.testCode);
      this.$axios
        .post(`${this.rt}/l/api/tools02/tag/register`, params)
        .then((response) => {
          console.log(response);
          if (response.data.status === 200) {
            this.$store.dispatch("setUserData");
            this.$store.dispatch("tools02/setTagList");
            this.$router.go(-1);
          } else if (response.data.status === 400) {
            this.validationErrorData = response.data.validationErrorData;
            return;
          } else if (response.data.status === 401) {
            alert(response.data.message);
            this.$router.push("/login");
          } else {
            alert(this.apiErrorMessage);
            return;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    registerPixelData() {
      let params = new URLSearchParams();
      params.append("user_pixel_id", this.tagId);
      params.append("name", this.tagData.name);
      params.append("pixel_id_for_api", this.tagData.mediaTagId);
      params.append("access_token", this.tagData.accessToken);
      params.append("test_code", this.tagData.testCode);
      this.$axios
        .post(`${this.rt}/l/api/tools02/media/facebook/register-pixel-data`, params)
        .then((response) => {
          console.log(response);
          if (response.data.status === 200) {
            this.$store.dispatch("tools02/setPixels");
            this.$store.dispatch("setUserData");
            this.$router.go(-1);
          } else if (response.data.status === 400) {
            this.facebookValidationErrorData = response.data.validationErrorData;
            return;
          } else if (response.data.status === 401) {
            alert(response.data.message);
            this.$router.push("/login");
          } else {
            alert(this.apiErrorMessage);
            return;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.note {
  margin-top: 5px;
  font-size: 12px;
  color: #666;
}

.validation-error-message {
  font-size: 12px;
  color: red;
}

.button-cover {
  display: flex;
  justify-content: center;
  align-items: center;

  .el-button {
    margin: 0 20px;
  }
}
</style>
